export default [
  {
    width: 20,
    header: {
      type: 'text',
      caption: 'User',
    },
    cell: {
      type: 'slot',
      name: 'user',
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Public API Key',
    },
    cell: {
      type: 'text',
      value: (e) => e.clientId,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Key name',
    },
    cell: {
      type: 'text',
      value: (e) => e.appName,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Status',
    },
    cell: {
      type: 'slot',
      name: 'status',
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Date',
    },
    cell: {
      type: 'slot',
      name: 'date',
    },
  },
  {
    width: 45,
    header: {
      type: 'text',
      caption: 'Permissions',
    },
    cell: {
      type: 'slot',
      name: 'permissions',
    },
  },
  {
    width: 5,
    header: {
      type: 'text',
      caption: '',
    },
    cell: {
      type: 'slot',
      name: 'change',
    },
  },
];
